const baseURL3 = "https://friendserp.newfriendsjewellers.com:8085";


export default baseURL3;